<div class="audio-video-failure-modal-container">
  <div class="audio-video-failure-modal-container__header">
    <div class="sub-header">Audio and/or Video Failure</div>
  </div>
  <div class="audio-video-failure-modal-container__body">
    <p>There seems to be an issue with the audio and/or video.</p>
    <p>
      Please reach out to support before canceling this session:
      <a href="tel:{{ (client$ | async)?.supportPhoneNumber | phone }}">{{
        (client$ | async)?.supportPhoneNumber | phone
      }}</a>
    </p>
  </div>
  <div class="audio-video-failure-modal-container__footer">
    <app-button type="warning" (buttonClick)="this.cancelPackageOnUserRequest()">
      Cancel Session
    </app-button>
  </div>
</div>
